export default "__VITE_ASSET__DMvKdnLQ__"